import type { ThemeConfig } from 'antd';

export const createAntdTheme = (mode: 'light' | 'dark' = 'light'): ThemeConfig => {
  const isDark = mode === 'dark';

  return {
  token: {
    colorPrimary: '#0077CC',
    colorSuccess: '#21734B',
    colorWarning: '#785600',
    colorError: '#B42335',
    colorInfo: '#003366',
    colorTextBase: isDark ? '#e7eef8' : '#002D5A',
    colorText: isDark ? '#e7eef8' : '#002D5A',
    colorTextSecondary: isDark ? '#9fb0c7' : '#4B5F73',
    colorTextPlaceholder: isDark ? '#7e90aa' : '#8a9ab0',
    colorIcon: isDark ? '#9fb0c7' : '#66758c',
    colorBgBase: isDark ? '#0d1a2c' : '#ffffff',
    colorBgContainer: isDark ? '#0d1a2c' : '#ffffff',
    colorBgElevated: isDark ? '#0d1a2c' : '#ffffff',
    colorFillSecondary: isDark ? '#13243a' : '#EAF5F7',
    colorFillTertiary: isDark ? '#0a1626' : '#fbfdff',
    colorBorder: isDark ? '#1f3148' : '#D8E2EC',
    colorBorderSecondary: isDark ? '#1f3148' : '#D8E2EC',
    colorPrimaryBg: isDark ? '#102642' : '#EAF5F7',
    colorInfoBg: isDark ? '#102642' : '#e6f7ff',
    colorInfoBorder: isDark ? '#1f4b5e' : '#91d5ff',
    colorInfoText: isDark ? '#9fdcf2' : '#0958d9',
    borderRadius: 7,
    fontFamily: '"Inter", "Aptos", "Segoe UI", "Roboto", "Helvetica Neue", Arial, sans-serif',
    fontSize: 14,
    fontSizeSM: 13,
    controlHeight: 36,
    controlHeightSM: 32,
    controlHeightLG: 40,
  },
  components: {
    Button: {
      borderRadius: 7,
      fontWeight: 600,
      controlHeight: 36,
      controlHeightSM: 32,
      controlHeightLG: 40,
      paddingInline: 14,
      paddingInlineSM: 12,
      paddingInlineLG: 18,
    },
    Card: {
      borderRadiusLG: 8,
      colorBorderSecondary: isDark ? '#1f3148' : '#D8E2EC',
    },
    Select: {
      optionSelectedBg: isDark ? '#0077CC' : '#EAF5F7',
      optionSelectedColor: '#ffffff',
      optionActiveBg: isDark ? '#13243a' : '#f5f5f5',
    },
    Table: {
      headerBg: '#EAF5F7',
      headerColor: '#4B5F73',
      rowHoverBg: '#F5F8FC',
    },
    Tooltip: {
      colorBgSpotlight: '#002D5A',
      borderRadius: 4,
    },
  },
  };
};

export default createAntdTheme();
